"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    explore: { path: "/explore" },
    guestHome: {
        path: "/",
    },
    getHelp: {
        path: "/properties/get-help",
    },
    noProperty: {
        path: "/properties/no-property",
    },
    guestDocumentUploadDetail: {
        path: "/file/:id",
    },
    guestDocumentUploadFile: {
        path: "/view-file/:id",
    },
    guestElevationCertificates: {
        path: "/elevation-certificates",
    },
    guestUploadElevationCertificates: {
        path: "/upload-elevation-certificates",
    },
    residentProperty: {
        path: "/properties/:propertyId",
    },
    residentSavedView: {
        path: "/view/:savedViewId",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3Vlc3RzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vcm91dGluZy9ndWVzdHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQXNDO0FBRXpCLFFBQUEsTUFBTSxHQUFHLElBQUEsbUJBQVcsRUFBQztJQUNoQyxPQUFPLEVBQUUsRUFBRSxJQUFJLEVBQUUsVUFBVSxFQUFFO0lBQzdCLFNBQVMsRUFBRTtRQUNULElBQUksRUFBRSxHQUFHO0tBQ1Y7SUFDRCxPQUFPLEVBQUU7UUFDUCxJQUFJLEVBQUUsc0JBQXNCO0tBQzdCO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsSUFBSSxFQUFFLHlCQUF5QjtLQUNoQztJQUNELHlCQUF5QixFQUFFO1FBQ3pCLElBQUksRUFBRSxXQUFXO0tBQ2xCO0lBQ0QsdUJBQXVCLEVBQUU7UUFDdkIsSUFBSSxFQUFFLGdCQUFnQjtLQUN2QjtJQUNELDBCQUEwQixFQUFFO1FBQzFCLElBQUksRUFBRSx5QkFBeUI7S0FDaEM7SUFDRCxnQ0FBZ0MsRUFBRTtRQUNoQyxJQUFJLEVBQUUsZ0NBQWdDO0tBQ3ZDO0lBQ0QsZ0JBQWdCLEVBQUU7UUFDaEIsSUFBSSxFQUFFLHlCQUF5QjtLQUNoQztJQUNELGlCQUFpQixFQUFFO1FBQ2pCLElBQUksRUFBRSxvQkFBb0I7S0FDM0I7Q0FDRixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIGV4cGxvcmU6IHsgcGF0aDogXCIvZXhwbG9yZVwiIH0sXG4gIGd1ZXN0SG9tZToge1xuICAgIHBhdGg6IFwiL1wiLFxuICB9LFxuICBnZXRIZWxwOiB7XG4gICAgcGF0aDogXCIvcHJvcGVydGllcy9nZXQtaGVscFwiLFxuICB9LFxuICBub1Byb3BlcnR5OiB7XG4gICAgcGF0aDogXCIvcHJvcGVydGllcy9uby1wcm9wZXJ0eVwiLFxuICB9LFxuICBndWVzdERvY3VtZW50VXBsb2FkRGV0YWlsOiB7XG4gICAgcGF0aDogXCIvZmlsZS86aWRcIixcbiAgfSxcbiAgZ3Vlc3REb2N1bWVudFVwbG9hZEZpbGU6IHtcbiAgICBwYXRoOiBcIi92aWV3LWZpbGUvOmlkXCIsXG4gIH0sXG4gIGd1ZXN0RWxldmF0aW9uQ2VydGlmaWNhdGVzOiB7XG4gICAgcGF0aDogXCIvZWxldmF0aW9uLWNlcnRpZmljYXRlc1wiLFxuICB9LFxuICBndWVzdFVwbG9hZEVsZXZhdGlvbkNlcnRpZmljYXRlczoge1xuICAgIHBhdGg6IFwiL3VwbG9hZC1lbGV2YXRpb24tY2VydGlmaWNhdGVzXCIsXG4gIH0sXG4gIHJlc2lkZW50UHJvcGVydHk6IHtcbiAgICBwYXRoOiBcIi9wcm9wZXJ0aWVzLzpwcm9wZXJ0eUlkXCIsXG4gIH0sXG4gIHJlc2lkZW50U2F2ZWRWaWV3OiB7XG4gICAgcGF0aDogXCIvdmlldy86c2F2ZWRWaWV3SWRcIixcbiAgfSxcbn0pO1xuIl19